// src/components/Users.js
import React from "react"
import UserList from "./UserList"
import UserDetails from "./UserDetails"

const Users = ({ selectedUser, setSelectedUser }) => {
  return (
    <div>
      {!selectedUser && <UserList onSelectUser={(u) => setSelectedUser(u)} />}

      {selectedUser && (
        <UserDetails
          userId={selectedUser.userId}
          onBack={() => setSelectedUser(null)}
        />
      )}
    </div>
  )
}

export default Users
